import { render, staticRenderFns } from "./CompanyTile.vue?vue&type=template&id=3901157c&scoped=true&lang=pug&"
import script from "./CompanyTile.vue?vue&type=script&lang=js&"
export * from "./CompanyTile.vue?vue&type=script&lang=js&"
import style0 from "./CompanyTile.vue?vue&type=style&index=0&id=3901157c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3901157c",
  null
  
)

export default component.exports